export const VERSION = '6.18.0'; // x-release-please-version
